import {fetchCheckSmsPage, fetchLoanInfoPage, fetchSetAccessToken} from "./app";

const FETCH_SEND_SMS_START = 'FETCH_SEND_SMS_START'
const FETCH_SEND_SMS_SUCCESS = 'FETCH_SEND_SMS_SUCCESS'
const FETCH_SEND_SMS_CLIENT_NOT_FOUND = 'FETCH_SEND_SMS_CLIENT_NOT_FOUND'
const FETCH_SEND_SMS_FAILURE = 'FETCH_SEND_SMS_FAILURE'
const FETCH_CHECK_SMS_START = 'FETCH_CHECK_SMS_START'
const FETCH_CHECK_SMS_SUCCESS = 'FETCH_CHECK_SMS_SUCCESS'
const FETCH_CHECK_SMS_CODE_INVALID = 'FETCH_CHECK_SMS_CODE_INVALID'
const FETCH_CHECK_SMS_FAILURE = 'FETCH_CHECK_SMS_FAILURE'

const sendSmsStart = () => {
    return {
        type: FETCH_SEND_SMS_START
    }
}

const sendSmsSuccess = (data) => {
    return {
        type: FETCH_SEND_SMS_SUCCESS,
        payload: data,
    }
}

const sendSmsError = ({message}) => {
    return {
        type: FETCH_SEND_SMS_FAILURE,
        payload: message
    }
}

const sendSmsClientNotFound = () => {
    return {
        type: FETCH_SEND_SMS_CLIENT_NOT_FOUND
    }
}

const checkSmsStart = () => {
    return {
        type: FETCH_CHECK_SMS_START
    }
}

const checkSmsSuccess = () => {
    return {
        type: FETCH_CHECK_SMS_SUCCESS,
    }
}

const checkSmsCodeInvalid = () => {
    return {
        type: FETCH_CHECK_SMS_CODE_INVALID
    }
}

const checkSmsError = ({message}) => {
    return {
        type: FETCH_CHECK_SMS_FAILURE,
        payload: message
    }
}

const fetchSendSms = (loanService, dispatch) => (iin) => {
    dispatch(sendSmsStart())
    loanService.sendSms(iin)
        .then((data) => {
            const {error} = data
            if (error !== undefined) {
                const {code} = error
                if (code === 404) {
                    dispatch(sendSmsClientNotFound())
                } else {
                    const {message} = error
                    dispatch(sendSmsError(message))
                }
            } else {
                dispatch(sendSmsSuccess(data))
                fetchCheckSmsPage(dispatch)()
            }
        })
        .catch((err) => {
            dispatch(sendSmsError(err))
        });
}

const fetchCheckSms = (loanService, dispatch) => (verificationId, smsCode) => {
    dispatch(checkSmsStart())
    loanService.checkSms(verificationId, smsCode)
        .then((data) => {
            const {error} = data
            if (error !== undefined) {
                const {code} = error
                if (code === 404) {
                    dispatch(checkSmsCodeInvalid())
                } else {
                    const {message} = error
                    dispatch(sendSmsError(message))
                }
            } else {
                dispatch(checkSmsSuccess())
                fetchSetAccessToken(dispatch)(data)
                fetchLoanInfoPage(dispatch)()
            }
        })
        .catch((err) => dispatch(checkSmsError(err)));
}

export {
    FETCH_SEND_SMS_START,
    FETCH_SEND_SMS_SUCCESS,
    FETCH_SEND_SMS_CLIENT_NOT_FOUND,
    FETCH_SEND_SMS_FAILURE,
    FETCH_CHECK_SMS_START,
    FETCH_CHECK_SMS_SUCCESS,
    FETCH_CHECK_SMS_CODE_INVALID,
    FETCH_CHECK_SMS_FAILURE,
    fetchSendSms,
    fetchCheckSms,
}
